export const leaveDetailConstants = {
    GET_SUCCESS: "GET_LEAVE_DETAIL_SUCCESS",
    GET_FAILURE: "GET_LEAVE_DETAIL_FAILURE",
    GET_LIST_DETAIL: "GET_LIST_DETAIL"
};
